// src/components/finance/steps/EligibilityResult.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../styles/LoanSteps.css';

const EligibilityResult = ({ result, car, onClose }) => {
  const navigate = useNavigate();

  const handleContinue = () => {
    onClose();
    // Navigate to finance page or booking page
    navigate('/finance');
  };

  return (
    <div className="result-container">
      {result.eligible ? (
        <>
          <div className="success-animation">
            <svg width="100" height="100" viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="45" fill="#10B981" opacity="0.2"/>
              <path d="M30 50 L45 65 L70 35" stroke="#10B981" strokeWidth="6" fill="none" strokeLinecap="round"/>
            </svg>
          </div>

          <h2 className="result-title success">Congratulations!</h2>
          <p className="result-message">You are eligible for maximum loan amount upto</p>

          <div className="eligible-amount-card">
            <div className="amount-label">₹</div>
            <div className="amount-value">{parseFloat(result.eligible_amount).toLocaleString('en-IN')}</div>
          </div>

          <div className="loan-details-grid">
            <div className="detail-card">
              <div className="detail-label">Rate of Interest</div>
              <div className="detail-value">{result.interest_rate_range}</div>
            </div>
            <div className="detail-card">
              <div className="detail-label">Down payment</div>
              <div className="detail-value">15%</div>
            </div>
          </div>

          <div className="offers-section">
            <h3>OFFERS FOR YOU</h3>
            
            <div className="offer-card featured">
              <div className="offer-badge">PRE-APPROVED OFFER</div>
              <div className="offer-amount">₹{parseFloat(result.eligible_amount).toLocaleString('en-IN')}</div>
              <p className="offer-description">Get same day delivery of your car</p>
              <p className="offer-validity">Valid till 28 February 2026</p>
            </div>

            <div className="offer-card">
              <div className="offer-badge">FLEXI PAYMENT OPTION</div>
              <div className="offer-title">Pay 23% lower EMIs</div>
              <p className="offer-description">Buy your dream car with lighter EMIs today and pay the balance at the end</p>
              <button className="offer-link">Know more →</button>
            </div>

            <div className="offer-card">
              <div className="offer-badge">NO COST EMI UPTO</div>
              <div className="offer-amount">₹1,00,000</div>
              <p className="offer-description">Don't compromise on your dream car, pay no-cost EMI lets you covered!</p>
              <button className="offer-link">View details →</button>
            </div>
          </div>

          <button className="accept-button" onClick={handleContinue}>
            Accept & proceed
          </button>
        </>
      ) : (
        <>
          <div className="error-animation">
            <svg width="100" height="100" viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="45" fill="#EF4444" opacity="0.2"/>
              <path d="M35 35 L65 65 M65 35 L35 65" stroke="#EF4444" strokeWidth="6" strokeLinecap="round"/>
            </svg>
          </div>

          <h2 className="result-title error">Not Eligible</h2>
          <p className="result-message">
            Unfortunately, you don't meet the current eligibility criteria for a loan. 
            Please contact our support team for alternative options.
          </p>

          <div className="contact-support-card">
            <h3>Need Help?</h3>
            <p>Our finance experts can help you explore other options</p>
            <button className="contact-button">
              📞 Contact Support
            </button>
          </div>

          <button className="close-button-secondary" onClick={onClose}>
            Close
          </button>
        </>
      )}
    </div>
  );
};

export default EligibilityResult;